module.exports = __webpack_public_path__ + "img/picto-calculette.b8e18bb9.svg";